// extracted by mini-css-extract-plugin
module.exports = {"content":"AuthorizeToLogin_content__3PzPc","sendOtp":"AuthorizeToLogin_sendOtp__J7dLD"};